import React, { memo } from 'react';
import { colors } from '@keen.io/colors';
export var markMotion = {
    initial: { opacity: 0.3, scale: 0.2 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.3 },
    exit: { opacity: 0, scale: 0.3 },
};
var Mark = function (_a) {
    var color = _a.color, x = _a.x, y = _a.y, _b = _a.outerRadius, outerRadius = _b === void 0 ? 10 : _b, _c = _a.innerRadius, innerRadius = _c === void 0 ? 4 : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 4 : _d;
    return (React.createElement("g", { pointerEvents: "none" },
        React.createElement("circle", { cx: x, cy: y, r: outerRadius, stroke: colors.white['500'], strokeWidth: strokeWidth, fill: color }),
        React.createElement("circle", { cx: x, cy: y, r: innerRadius, fill: colors.white['500'] })));
};
export default memo(Mark);
